function homeBrandLogos(){
  var dataSectionType = $('[data-section-type="brand-logos-section"]');
  var id = dataSectionType.attr('data-section-id');    
  var ItemsPerView = +dataSectionType.attr('data-item-per-view');
  var ItemsRow = +dataSectionType.attr('data-item-row');
  var ItemsSpace = +dataSectionType.attr('data-item-space');
  var autoHeight = +dataSectionType.attr('data-auto-height') || false;
  var ItemsLimit = +dataSectionType.attr('data-blocks-limit');
  var Autoplay = +dataSectionType.attr('data-autoplay') * 1000;
  var mobileSlides = +dataSectionType.attr('data-small-screen-items') || 1;
  var initAutoplay = Autoplay ? {    delay: Autoplay  } : false;    
  var swiper = new Swiper('#swiper-' + id + '-slider', {  
    pagination: {
      el: '#swiper-' + id + '-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '#swiper-' + id + '-next',
      prevEl: '#swiper-' + id + '-prev'
    },
    loop: false,
    slidesPerView: ItemsPerView,   
    slidesPerColumn: ItemsRow,
    spaceBetween: ItemsSpace,
    autoHeight: autoHeight,    
    simulateTouch: true,
    autoplay: initAutoplay,
    breakpoints: {
          320: {
            slidesPerView: mobileSlides,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: ItemsPerView,
            spaceBetween: 30,
          },
    },
  });
  }
  $(document).ready(function(){    
    homeBrandLogos();
  })
  $(document)
  .on('shopify:section:load', homeBrandLogos)
  .on('shopify:section:unload', homeBrandLogos)